import axios from 'axios';

export default function updateUnassignUrl({ payload }) {
    return new Promise((resolve, reject) => axios
        .post('/distributor/system-admin/api/v1/unassign-url', {
            node_id: payload.node_id,
            urls: payload.urls,
        })
        .then((response) => resolve(response.data))
        .catch((error) => {
            if (error.response && error.response.data) {
                const err = new Error(error.response.data.message);
                err.data = error.response.data;
                reject(err);
            } else {
                reject(error);
            }
        })
    );
}
